import {Tooltip as Tooltip} from "rsuite";
import React from "react";

const textStyle = {
  fontSize: 14,
  lineHeight: 1,
}

const p1Style = {
  marginBottom: 5,
  paddingBottom: 0,
  marginTop: 10
}

export const movementTotalTooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>
      The total number of significant movements by the Resident, or with assistance by staff or other visitors, during the specified period.
    </p>
  </Tooltip>
);

export const movementScoreTooltip = (
  <Tooltip>
    <div style={{textAlign: 'left', ...textStyle, ...p1Style}}>
      <p>
        The Resident’s Movement Score on a 0-10 scale, based on the number of significant body movements the resident has made over the specified period, as calculated by Keenly Health’s proprietary radar movement algorithm:
      </p>
      <ul>
        <li>A red dot, and a score less than 4, indicates little to no significant movements.</li>
        <li>An orange dot, and a score between 4 and 7, indicates the resident is moving fairly well but less than an active person moves.</li>
        <li>A green dot, and a score of 7 or above, indicates the resident is moving at a physically healthy level.</li>
      </ul>
    </div>
  </Tooltip>
);

export const graphTooltip = (
  <Tooltip>
    <p style={{textAlign: 'left', ...textStyle, ...p1Style}}>This graph shows Respiration Rate, Movement and Out of Range (Out of Bed) at the times on the horizontal (bottom) axis:</p>
    <ul style={{textAlign: 'left', ...textStyle}}>
      <li>Times Out of Range (Out of Bed) are shown as gray cross-hatched areas.</li>
    </ul>
  </Tooltip>
);

export const sleepBarTooltip = (
  <Tooltip>
    <p style={{ textAlign: 'left', ...textStyle, ...p1Style}}>
      A blue line is added to this bar for each minute of resident sleep. During consecutive minutes of sleep, the bar will appear solid, indicating deeper sleep. Frequent gaps between blue lines indicate lighter, interrupted sleep.
    </p>
  </Tooltip>
);

export const presenceBarTooltip = (
  <Tooltip>
    <p style={{ textAlign: 'left', ...textStyle, ...p1Style}}>
      A dark gray line is added to this bar for each minute a second presence (visitor) is detected in the room other than in the bed. This may be the resident themself in the process of entering or exiting the bed or room. If a second person is in the room continuously, the bar will appear solid.
    </p>
  </Tooltip>
);

